export default __webpack_public_path__ + "static/media/logo_credencial.0ff81c9e.jpeg";